export const NAVE = 'nave';
export const TABLERO = 'tablero';